<template>
    <div></div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { OrderStore } from "../OrderStore";

export default {
    props: {
        employeeId: Number | String,
        userId: Number | String,
        avatar: Number | String,
    },

    data() {
        return {
            tableData3: [],
            limit: 400,
            employeeCredit: {},
            employee: {
                profiles: {},
            },
            order: [],
            orderTotal: OrderStore.Amount,
            dayTotal: 0,
        };
    },

    filters: {
        moneyFormat(val = 0) {
            const money = Number(val).toFixed(2);
            return `RD$ ${money}`;
        },
    },

    computed: {
        ...mapGetters(["shopLimit"]),
        currentDayTotal() {
            return parseFloat(this.orderTotal) + parseFloat(this.dayTotal);
        },

        balance() {
            return this.shopLimit - this.dayTotal;
        },
    },

    async mounted() {
        await this.getUser();
        await this.getCreditLimit();
        await this.getDayTotal();
        await this.addOrder();
        this.avatar =
            "https://app.cashdepotint.com/avatars/" + this.employeeId + ".jpg";
    },

    methods: {
        getProducts() {
            axios
                .get(`${API_URL}/foods`)
                .then((res) => {
                    this.tableData3 = res.data;
                })
                .catch((err) => {
                    this.fallBack();
                });
        },

        getUser() {
            axios
                .get(
                    `${API_URL}/users?q=(id:${this.userId})&relationships=profiles`
                )
                .then(({ data }) => {
                    this.employee = data[0];
                });
        },

        getCreditLimit() {
            axios
                .get(`${API_URL}/employees/${this.employeeId}/limit_credit`)
                .then(({ data }) => {
                    this.employeeCredit = data;
                });
        },

        getDayTotal() {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(
                    `${API_URL}/orders/employee-total/${this.employeeId}/${date}`
                )
                .then((res) => {
                    this.dayTotal = res.data.sum;
                });
        },

        handleSelectionChange(selectedRows) {
            const moreThanLimit = this.checkLimit(selectedRows);
            if (!moreThanLimit) {
                this.order = selectedRows;
            } else {
                this.$notify({
                    title: "Aviso",
                    message: `El limite para este cliente es de ${this.shopLimit} por dia`,
                    type: "info",
                });
            }
        },

        checkLimit(rows, allRows) {
            let value;
            if (rows && rows.length) {
                const currentPrice = parseFloat(rows[rows.length - 1].price);
                value = parseFloat(this.currentDayTotal);
            } else {
                value = this.dayTotal;
            }

            if (this.shopLimit <= value) {
                if (allRows) {
                    this.$refs.multipleTable.clearSelection();
                } else {
                    this.$refs.multipleTable.toggleRowSelection(
                        rows[rows.length - 1],
                        false
                    );
                }
                return true;
            }
            return false;
        },

        cancelOrder() {
            this.orderTotal = 0;
            this.$emit("cancel-order");
        },

        async addOrder() {
            if (this.currentDayTotal <= this.shopLimit) {
                if (this.orderTotal <= 0) {
                    this.$notify({
                        title: "Error",
                        message: `El valor de la orden no puede ser cero`,
                        type: "error",
                    });
                } else {
                    const discount = await this.getDiscount({
                        employee_id: this.employee.id,
                        shop_id: this.$store.state.user.id,
                        subtotal: this.orderTotal,
                    });

                    this.$emit("add-order", {
                        items: this.order,
                        subtotal: this.orderTotal,
                        retention: this.retention,
                        total: this.orderTotal - discount,
                        discount: discount,
                        employee: this.employee,
                        date: moment().format("YYYY-MM-DD"),
                    });
                }
            } else {
                this.$notify({
                    title: "Aviso",
                    message: `El limite para este cliente es de ${this.shopLimit} por dia`,
                    type: "info",
                });
            }
        },

        fallBack() {
            this.tableData3 = [
                {
                    name: "Tradicional",
                    price: 150,
                    description: "Habichuelas rojas, frijoles, wasacaca",
                },
                {
                    name: "Especial",
                    price: 150,
                    description: "Habichuelas rojas, frijoles, wasacaca",
                },
                {
                    name: "Ligera",
                    price: 150,
                    description: "Habichuelas rojas, frijoles, wasacaca",
                },
                {
                    name: "Otra",
                    price: 150,
                    description: "Habichuelas rojas, frijoles, wasacaca",
                },
            ];
        },
        getDiscount(orderData) {
            return axios
                .post(`${API_URL}/orders/get-discount`, orderData)
                .then(({ data }) => Number(data || 0));
        },
    },
};
</script>

<style>
th .el-checkbox {
    display: none;
}
</style>
